<div class="search-wrapper" style="width: 280px;" (blur)="hadText = false">
    <div class="input-group input-group-sm" >
      
      <input type="text" autocomplete="off" [style.caretColor]="accentColor" class="form-control editable" [placeholder]="placeholderText" [(ngModel)]="searchText" #dashModuleSearch (keyup.escape)="(dashModuleSearch.value.length) ? clearEvent() : null" (keyup.arrowup)="moveSelectionUp()" (keyup.arrowdown)="moveSelectionDown()" (keyup)="processKeyEvent($event)" aria-label="Search" aria-describedby="basic-addon2" matTooltip="Press Enter to search, Esc to clear" aria-label="Search">
      <div class="input-group-append">
        <button class="btn btn-outline-primary" [title]="!hadText ? 'Show List' : 'Hide List'" name="basic-addon3" *ngIf="allDataDropdown" type="button" (click)="openDropdown()" (keyup.arrowup)="moveSelectionUp()" (keyup.arrowdown)="moveSelectionDown()" (keyup.enter)="processKeyEvent($event)">
          <i class="fal" [ngClass]="{'fa-chevron-square-down': !hadText, 'fa-chevron-square-up': hadText}"></i>
        </button>
        <button *ngIf="!selectionMode" class="btn btn-primary" name="basic-addon2" [disabled]="dashModuleSearch.value.length < 2" type="button" (click)="searchEvent(dashModuleSearch.value)">
          <i class="fal fa-search"></i>
        </button>
      </div>
    </div>
    <div *ngIf="dropDown">
        <div *ngIf="loading; else defaultDataDropdown" class="search-dropdown no-results">
            Please wait...
        </div>
    </div>
  </div>
  
  <ng-template #defaultConfiguration></ng-template>
  
  <ng-template #defaultDataDropdown>
    <div *ngIf="hadText">
      <div *ngIf="dataToShow.length > 0; else noResults" class="search-dropdown">
        <cdk-virtual-scroll-viewport class="scrollViewport" [itemSize]="maxResults" (scrolledIndexChange)="loadNextPage($event)">
          <ul>
            <ng-container *cdkVirtualFor="let match of dataToShow; let i = index; trackBy: trackByUID; templateCacheSize: 1">
              <li class="search-match" [ngClass]="{'highlight': i == keySelectionIndex}" (click)="outputModel(match)">
                <span class="ms-2 matchName">
                    <i *ngIf="match.reviewed === false" matTooltip="This keyword has not been reviewed" [matTooltipPosition]="'above'" class="fal fa-exclamation-triangle text-warning"></i>
                    {{ setTextToDisplay(match) }}
                    <span class="badge badge-secondary ms-3 pe-2 ps-2" style="justify-content: flex-end; align-items: start;" matTooltip="Number of times this keyword has been used">{{ match.appears }}</span>
                </span>
              </li>
            </ng-container>
          </ul>
        </cdk-virtual-scroll-viewport>
      </div>
      <ng-template #noResults>
        <div class="search-dropdown no-results dropdown-intro">
          {{ searchText.length ? 'No results. Contact an admin if you think a new keyword should be added to the system.' : 'Start typing to see available keywords' }}
        </div>
      </ng-template>
    </div>
  </ng-template>
  